import React from "react";
import { CircleDollarSign, Play, X } from "lucide-react";

const BondSpinStageActions = ({
  hasSelectedBet = false,
  canPlaceBet = true,
  disabled = false,
  onCancel,
  onPlay,
  onPlaceBet,
}) => (
  <div
    className={`bplay-spin-actions${hasSelectedBet ? " has-active-bet" : ""}`}
  >
    {hasSelectedBet ? (
      <>
        <button
          type="button"
          className="bplay-spin-action bplay-spin-action-cancel"
          disabled={disabled}
          onClick={onCancel}
        >
          <X size={15} strokeWidth={2.5} />
          <span>Cancel</span>
        </button>
        <button
          type="button"
          className="bplay-spin-action bplay-spin-action-play"
          disabled={disabled}
          onClick={onPlay}
        >
          <Play size={15} strokeWidth={2.5} />
          <span>Play</span>
        </button>
      </>
    ) : canPlaceBet ? (
      <button
        type="button"
        className="bplay-spin-action bplay-spin-action-bet"
        disabled={disabled}
        onClick={onPlaceBet}
      >
        <CircleDollarSign size={15} strokeWidth={2.25} />
        <span>Reverse ticket</span>
      </button>
    ) : null}
  </div>
);

export default BondSpinStageActions;
